import { render, staticRenderFns } from "./prizeWheelForm.vue?vue&type=template&id=ea05a1d0"
import script from "./prizeWheelForm.vue?vue&type=script&lang=js"
export * from "./prizeWheelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports